$(function () {
	$('.js-tab-item').click(function (e) {
		e.preventDefault();
		$(this).siblings().removeClass('tab__item_active');
		$(this).addClass('tab__item_active');
		var data = $(this).data('tab');
		$('.js-tab-content').removeClass('tab-content_active');
		$('.js-tab-content[data-tab=' + data + ']').addClass('tab-content_active');
	});
})